<template>
  <v-app id="sandbox">
    <div class="app__loading-spinner"></div>
    <div class="page">
      <div class="page_inner">
        <app-header-block/>
        <div class="list" >
          <router-view></router-view>
        </div>
        <footer id="footer">
          <div class="footer_a_list">
            <div class="footer_a_list__items">

            </div>
          </div>
        </footer>
      </div>
    </div>
  </v-app>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Steel Hit | Головний співочий конкурс року'
    },
    data () {
      return {
        sideNav: false
      }
    },
  }
</script>

<style lang="stylus">
  @import './assets/stylus/main.styl'
</style>



// WEBPACK FOOTER //
// src/App.vue